import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const RemoteView = () => {
  return <TMSIframe path="/remote-view" />;
};

export default React.memo(RemoteView);
